import Header from '../components/Header';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';
import TheApp from '../components/TheApp';
import { Helmet } from "react-helmet-async";
import { useState } from 'react';


export default function About() {


    const isLaunched = false;



  
  return (
    <>
     <Helmet>
            <title>OutfitFind About Us| Fashion, Outfits & Style </title>
           <meta
            name="description"
            content="Discover trending fashion, stylish outfits, and must-have looks on OutfitFind. Find your style and shop your favorite fashion online."
          />
                </Helmet>
      <Header />
      <main>
        {/* About Section */}
        <section className="about-section" style={{ paddingTop: '10rem' }}>
          <div className="container">
            <div className="about-content">
              <div className="text-center">
                <div className="section-eyebrow">ABOUT OUTFITFIND</div>
                <h2 className="section-title">We make getting <span className="italic">dressed feel easier.</span></h2>
              </div>

              <FadeInSection className="mt-5">
                <p className="about-quote"> OutfitFind was built to make outfit discovery easier - bringing together complete, professionally styled looks while helping people discover standout homegrown Indian fashion brands along the way.</p>
             
              
              </FadeInSection>
            </div>
          </div>
        </section>



        <section className="why-section">
      <div className="container">
        <div className="row align-items-center g-5 justify-content-center">
          
          {/* Left Column: Text & Editorial Content */}
          <div className="col-lg-6">
            <div className="pe-lg-3">
             
              <h2 className="why-heading">
                Why We Built <span>OutfitFind</span>
              </h2>

            
              <p className="why-body-text">
                Finding clothes is easy. Putting together the whole look is where it gets difficult. OutfitFind was created to bridge that gap by helping people discover complete outfits styled for real occasions, while making it easier to explore the individual pieces that bring each look together.
              </p>

              <div className="why-feature-pill">
                <i className="bi bi-sparkles"></i>
                <span>Complete Looks • Real Occasions • Effortless Discovery</span>
              </div>
            </div>
          </div>

          {/* Right Column: Strong Editorial Fashion Visual */}
          <div className="col-lg-5">
            <div className="editorial-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&q=60&w=700" 
                alt="Editorial Fashion Styling" 
                className="editorial-img"
              />
              <div className="editorial-badge">
                <p className="editorial-badge-title">Curated Editorial</p>
                <p className="editorial-badge-sub">Styled for modern everyday looks</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>



    <section className="founders-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="founders-card">
              
              {/* Header */}
              <span className="founders-tag">PERSPECTIVE</span>
              <h2 className="founders-heading">FOUNDER'S NOTE</h2>

              {/* Content Body */}
              <p className="founders-opening">
                OutfitFind started with a simple frustration.
              </p>

              <p className="founders-story">
                While shopping online for a trip, I found myself endlessly scrolling 
                through individual pieces and mentally trying to figure out what would 
                actually work together. The process felt more tiring than inspiring.
              </p>

              <p className="founders-idea">
                That made me wonder: what if there were one place where you could 
                discover the complete outfit first, and then explore every piece that 
                makes it work?
              </p>

              <p className="founders-close">
                That idea became OutfitFind.
              </p>

              <div className="founders-divider"></div>

              {/* Minimal Text Sign-off */}
              <div className="sign-off-block">
                <h4 className="sign-off-name">Palak Ughareja</h4>
                <p className="sign-off-title">Founder, OutfitFind</p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>



    <section className="mission-vision-section">
      <div className="container">
        <div className="row g-4">
          
          {/* Mission Column */}
          <div className="col-md-6">
            <div className="mv-card">
              <div className="mv-icon-wrapper">
                <i className="bi bi-compass"></i>
              </div>
              <span className="mv-tag">PURPOSE</span>
              <h3 className="mv-title">OUR MISSION</h3>
              <p className="mv-text">
                To make outfit discovery simpler, more inspiring, and more useful by helping people see the complete look before choosing the pieces.
              </p>
            </div>
          </div>

          {/* Vision Column */}
          <div className="col-md-6">
            <div className="mv-card">
              <div className="mv-icon-wrapper">
                <i className="bi bi-eye"></i>
              </div>
              <span className="mv-tag">FUTURE</span>
              <h3 className="mv-title">OUR VISION</h3>
              <p className="mv-text">
                To become a go-to fashion discovery platform where people can find what to wear, how to style it, and where to get it - all in one place.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>

      <div className="about-section py-3 d-flex align-items-center">
        <div className="container py-4">
          
          {/* Header Section */}
          <div className="text-center mx-auto mb-5" style={{ maxWidth: '650px' }}>
          <h2 className="why-heading">
               Connect With <span>OutfitFind</span>
              </h2>
            
            <p className="why-body-text leading-relaxed">
              Have questions about styling, outfit recommendations, or business collaborations? 
              Reach out to our team—we'd love to assist you!
            </p>
          </div>

          <div className="row g-4 align-items-stretch">
            
            {}
            <div className="col-lg-6 mx-auto">
              <div className="d-flex flex-column gap-4 h-100 ">
                
                {/* Direct Mail Card */}
                <a
                  href="mailto:outfitfind.in@gmail.com"
                  className=" text-decoration-none overflow-hidden "
                 
                 
                >
                  <div className="card-body p-4 p-md-5 mv-card">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div className="bg-white bg-opacity-25 rounded-3 p-3 d-inline-flex align-items-center justify-center">
                        <i className="bi bi-envelope-fill fs-4 text-white"></i>
                      </div>
                      <span className="badge bg-white bg-opacity-25 text-white px-3 py-2 rounded-pill fw-normal">
                        Official Mail
                      </span>
                    </div>

                    <p className="text-white-50 mb-1 small fw-semibold text-uppercase">
                      Send us an email
                    </p>
                    <h3 className="h4 fw-bold font-monospace text-wrap mb-4 text-white">
                      outfitfind.in@gmail.com
                    </h3>

                    <div className="cta-badge-pill"><span>Compose Email <i className="bi bi-arrow-right"></i></span></div>
                   
                  </div>
                </a>

             

              </div>
            </div>

         

          </div>
        </div>
      </div>

        {/* Download Section */}


    <TheApp />
       




      <section className="faq-section">
        <div className="container">
        
          <div className="row">
            <div className="col-md-8 mx-auto">
                    <FadeInSection className="faq-section">
              <h3 className="faq-title">Frequently Asked <span style={{ fontStyle: 'italic', color: 'var(--peach)' }}>Questions</span></h3>
              <div className="accordion" id="faqAccordion">
               {[
  {
    id: 'faq1',
    q: 'What is OutfitFind?',
    a: 'OutfitFind helps you discover complete outfits curated by stylists, making it easier to know what to wear.'
  },
  {
    id: 'faq2',
    q: 'How do I shop an outfit?',
    a: 'Open any outfit to view the individual products used in the look. Tap the product you like to continue to the available shopping option.'
  },
  {
    id: 'faq3',
    q: "Why is the price different from what I see on the brand's website?",
    a: "Product prices can change after an outfit is added to OutfitFind. The price shown on the brand's website at the time of purchase will be the current price."
  },
  {
    id: 'faq4',
    q: 'What if a product is out of stock?',
    a: 'Availability is controlled by the respective brand and can change at any time. If you find an unavailable product, you can report it to us so our team can review and update the outfit.'
  },
  {
    id: 'faq5',
    q: 'What should I do if a product link is not working?',
    a: 'Please report the issue through our support option or email us. Our team will check the link and update it where possible.'
  },
  {
    id: 'faq6',
    q: 'How do I save an outfit?',
    a: 'Use the save or bookmark option on an outfit to add it to your saved looks so you can come back to it later.'
  },
  {
    id: 'faq7',
    q: 'How do I report an incorrect price, broken link or other problem?',
    a: 'Contact us through the support option in the app or our customer-support email and mention the outfit or product involved. Screenshots are helpful where possible.'
  },
  {
    id: 'faq8',
    q: 'How do I delete my OutfitFind account?',
    a: "You can request account deletion through the account settings in the app or by contacting customer support. Your request will be processed according to OutfitFind's account-deletion and privacy policy."
  },
  {
    id: 'faq9',
    q: 'Are the outfits created by stylists?',
    a: "Yes. OutfitFind's looks are curated by stylists to help you discover complete outfits rather than individual products."
  }
].map((item, index) => (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#${item.id}`}>
                        {item.q}
                      </button>
                    </h2>
                    <div id={item.id} className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">{item.a}</div>
                    </div>
                  </div>
                ))}
              </div>
            </FadeInSection>

              </div>
          </div>
          </div>
          </section>

      </main>
      <Footer />
     
    </>
  );
}   